import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useOverlayContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
import { EditDocumentModal } from '../EditDocumentModal/EditDocumentModal';
import { toParsedRichText } from './toParsedRichText';
export const useEditQuillLegalTerms = (params)=>{
    const { showModal, showErrorToast } = useOverlayContext();
    const { t: commonTexts } = useLocaleKeys('common');
    const { api } = useStoreActions();
    const localContentByTermId = useRef(new Map());
    useEffect(()=>{
        localContentByTermId.current.clear();
    }, [
        params === null || params === void 0 ? void 0 : params.resetKey
    ]);
    const editQuillLegalTerms = async (legalTerm, variant)=>{
        let initialContent;
        const cachedContent = localContentByTermId.current.get(legalTerm.id);
        if (cachedContent) {
            initialContent = cachedContent;
        } else if (variant.type === 'local' && legalTerm.richTextId && variant.sourceId) {
            const result = await handleRequest(api.texts.getLegalTermsRichTextContent(variant.sourceId, legalTerm.richTextId));
            if (!result.success) {
                showErrorToast(commonTexts.toasts.failedToLoadDocumentContent());
                return;
            }
            initialContent = toParsedRichText(result.data.value);
        } else {
            initialContent = toParsedRichText(legalTerm.richTextContent);
        }
        const handleLocalSave = (content)=>{
            var _params_onLocalSave;
            localContentByTermId.current.set(legalTerm.id, content);
            params === null || params === void 0 ? void 0 : (_params_onLocalSave = params.onLocalSave) === null || _params_onLocalSave === void 0 ? void 0 : _params_onLocalSave.call(params, legalTerm.id, content);
        };
        await showModal({
            biName: 'edit_document_modal',
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(EditDocumentModal, {
                    variant: variant,
                    legalTermsId: legalTerm.id,
                    initialName: legalTerm.name,
                    initialContent: initialContent,
                    usedIn: legalTerm.contentType === 'quill' ? legalTerm.usedIn : undefined,
                    onLocalSave: handleLocalSave,
                    dismissModal: dismissModal
                });
            }
        });
    };
    return {
        editQuillLegalTerms
    };
};
